import React from 'react';
import PropType from 'prop-types';
import bem from '../../../frontend/scripts/utils/bem';

export default function Icon({
  iconClass,
  filter,
  strokeOnly,
  iconTitle,
  iconName,
  xLink,
}) {

  let iconsFile = '/wp-content/themes/arn/assets/icons/icons.svg';
  if(xLink) {
    iconsFile = xLink;
  }

  return (
    <div className={`pa-icon ${iconClass || ''}`}>
      <svg className={bem('pa-icon__symbol', strokeOnly ? 'stroke-only' : '')}>
        {iconTitle ? <title>{iconTitle}</title> : null}
        <use
          xlinkHref={`${iconsFile}#${iconName}`}
          filter={filter ? `url(#${filter})` : null}
        />
      </svg>
    </div>
  );
}

Icon.propTypes = {
  iconClass: PropType.string,
  filter: PropType.string,
  strokeOnly: PropType.bool,
  iconTitle: PropType.string,
  iconName: PropType.string.isRequired,
  xLink: PropType.string,
};
